// https://vuex.vuejs.org/en/mutations.html

export default {
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, { token, user }) {
    state.status = 'success'
    state.token = token
    state.user = user
  },
  auth_error (state) {
    state.status = 'error'
  },
  locale (state, locale) {
    localStorage.setItem('locale', locale)
    state.locale = locale
  },
  logout (state) {
    state.status = ''
    state.token = ''
    state.tokenExpiry = ''
    state.user = {}
  },
  account (state, account) {
    localStorage.setItem('account', account)
    state.account = account
  },
  calcTypes (state, types) {
    state.calcTypes = types
  },
  priceRuleTypes (state, types) {
    state.priceRuleTypes = types
  },
  genders (state, genders) {
    state.genders = genders
  },
  countries (state, countries) {
    state.countries = countries
  },
  languages (state, languages) {
    state.languages = languages
  },
  newReservation (state, reservation) {
    state.newReservation = reservation
  },
  navigation (state, navigation) {
    state.navigation = navigation
  },
  serviceTypes (state, serviceTypes) {
    state.serviceTypes = serviceTypes
  },
  prebuildTrip (state, prebuildTrip) {
    state.prebuildTrip = prebuildTrip
  },
  prebuildBlock (state, prebuildBlock) {
    state.prebuildBlock = prebuildBlock
  },
  serviceCategories (state, serviceCategories) {
    state.serviceCategories = serviceCategories
  },
  reservation (state, reservation) {
    state.reservation = reservation
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js